import Phone from '@mui/icons-material/Phone';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function PhoneIcon(props: FixMe) {
  return <Phone {...props} />;
}

export default PhoneIcon;
